import { render } from "./AuthChallengePin.vue?vue&type=template&id=503bc01a&ts=true"
import script from "./AuthChallengePin.vue?vue&type=script&lang=ts"
export * from "./AuthChallengePin.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__